import { useEffect } from 'react';
import { useExit } from '@wix/cli-ui-kit';
import { useSite } from '../../../site/index.js';
import { useDevEnvironment } from '../DevEnvironment.js';
import { useUpdateDeploymentTopologyForApp } from '../../../hooks/useUpdateDeploymentTopology.js';

export function useAppDeploymentTopologyUpdater() {
  const { devArmTag } = useDevEnvironment();
  const { siteId } = useSite();
  const updateTopology = useUpdateDeploymentTopologyForApp(siteId);
  const exit = useExit();

  useEffect(() => {
    updateTopology({ armTag: devArmTag, environment: 'development' }).catch(
      exit
    );
  }, [devArmTag, updateTopology, exit]);
}
